export const headerStyles = {
  TOP_CONTAINER:
    'flex flex-col md:flex-row items-center justify-center lg:space-x-16 bg-background',
  IMAGE: 'h-[40vh] md:h-full pt-6 md:pt-12 lg:min-w-[502px]',
  BUTTON: 'animate-fade-up flex justify-center items-center mt-6 grid gap-6',
  BOTTOM_CONTAINER: 'h-[30vh] flex justify-center items-center p-6 -mx-3 bg-secondary',
  BANNER: 'text-2xl md:text-3xl text-center text-white max-w-[80vw] animate-fade-up',
  HEADER: 'text-4xl font-extrabold text-secondary dark:text-foreground text-center mt-5',
  INPUT:
    'flex gap-20 justify-center h-30 rounded-full text-16 border-2 border-solid border-gray-400 w-30',
}

export const formStyles = {
  MAIN_CONTAINER:
    'grid w-full grid-cols-2 gap-2 px-12 mx-auto bg-white rounded-3xl p-9 shadow-propital md:gap-4 lg:max-w-lg animate-fade-up',
  LABEL: 'font-bold w-max text-primary',
  CIRCLE:
    'flex items-center justify-center transition-all rounded-full cursor-pointer text-inactive w-14 h-14 border-3',
}
